import styles from './styles.module.scss';

import { useContext, useEffect, useRef, useState } from 'react';
import { useAgent } from '../../hooks/useAgent';
import { useMousePosition } from '../../hooks/useMousePosition';
import { AgentContext } from '../../providers/AgentProvider';
import { useNavigate } from 'react-router-dom';
import Personagem from '../Personagem';

interface AgentProps extends React.HTMLAttributes<HTMLDivElement> {
    initialState?: number;
    setShowMessageBox: React.Dispatch<React.SetStateAction<boolean>>;
}

export const Agent = ({ className, setShowMessageBox, ...rest }: AgentProps) => {
    const agents = useAgent();
    const { providedAgent, setProvidedAgent } = useContext(AgentContext);
    const navigate = useNavigate()

    const mousePos = useMousePosition();
    const refEyeLeft = useRef<HTMLDivElement>(null);
    const refEyeRight = useRef<HTMLDivElement>(null);
    const [eyeLeftRot, setEyeLeftRot] = useState(0);
    const [eyeRightRot, setEyeRightRot] = useState(0);

    const characterRoute = () => {
        navigate("/characterMaker")
    };

    const showMessageBox = () => {
        setShowMessageBox(true);
    };

    return (
        <div className={`${styles.box} ${className}`} {...rest}>
            <div className={styles.content}>
                <div onClick={showMessageBox} className={styles.headWrapper} style={{transform: "scale(.5)"}}>
                <Personagem className={styles.personagem} Personagem={null}/>

                   </div> 
                <div onClick={characterRoute} className={styles.btn}>
                    <div style={{ textAlign: 'center' }} className={`fa fa-refresh`} />
                </div>
            </div>
        </div>
    );
};
